import { render, staticRenderFns } from "./resi.vue?vue&type=template&id=7dddc805&scoped=true&"
import script from "./resi.vue?vue&type=script&lang=js&"
export * from "./resi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dddc805",
  null
  
)

export default component.exports